import { useEffect } from 'react';
import { usePrompt } from '../App/hooks/usePrompt';
import { useAppDispatch, useAppSelector } from '../App/redux/store';
import { appManagerActions } from '../store/appManager/actions';
import { getFormIsSubmittedState } from '../store/appManager/reducer';

interface PromptCustomProps {
  when?: boolean;
  message?: string;
}

const defaultMessage =
  'Voulez-vous vraiment abandonner la saisie de ce formulaire ?';

const PromptCustom = ({
  when = true,
  message = defaultMessage,
}: PromptCustomProps) => {
  const formIsSubmitted = useAppSelector(getFormIsSubmittedState);
  const dispatch = useAppDispatch();

  useEffect(() => {
    return () => {
      dispatch(appManagerActions.formIsSubmitted.false());
    };
  }, [dispatch]);

  usePrompt(when && !formIsSubmitted, message);

  useEffect(() => {
    const handleBeforeUnload = (e: BeforeUnloadEvent) => {
      if (when && !formIsSubmitted) {
        e.preventDefault();
        e.returnValue = message;
      }
    };

    window.addEventListener('beforeunload', handleBeforeUnload);
    return () => window.removeEventListener('beforeunload', handleBeforeUnload);
  }, [when, formIsSubmitted, message]);

  return null;
};

export default PromptCustom;
